import React from 'react';
import { useLocale } from '@hooks/useLocale';
import { useTranslation } from 'next-i18next';
import Heading from '@components/ui/Heading';
import Container from '@components/global/Container';

import styles from './Error404Message.module.scss';

const Error404Message = () => {
  const { t } = useTranslation();
  const locale = useLocale();
  return (
    <div className={styles.wrapper}>
      <Container className={styles.container}>
        <div>
          <Heading semanticLevel="h1" styleLevel="1">
            {t('404.title')}
          </Heading>
          {locale !== 'fr' && <p>{t('404.line2')}</p>}
          <p>
            {`${t('404.line3.beforelink')} `}
            <a href={`/${locale}`}>{t('404.line3.homepage')}</a>
            {` ${t('404.line3.afterlink')}`}
          </p>

          <ul className={styles.categories}>
            <li>
              <a
                href={
                  locale === 'fr'
                    ? 'produits/camping-et-randonnee'
                    : '/products/camping-and-hiking'
                }
              >
                {t('404.categories.hike')}
              </a>
            </li>
            <li>
              <a
                href={
                  locale === 'fr'
                    ? 'produits/equipement-de-ski-et-de-planche'
                    : '/products/ski-and-snowsports'
                }
              >
                {t('404.categories.snowsports')}
              </a>
            </li>
            <li>
              <a href={locale === 'fr' ? 'produits/velo' : '/products/cycling'}>
                {t('404.categories.cycling')}
              </a>
            </li>
            <li>
              <a
                href={
                  locale === 'fr' ? 'produits/escalade' : '/products/climbing'
                }
              >
                {t('404.categories.climb')}
              </a>
            </li>
          </ul>
        </div>
      </Container>
    </div>
  );
};

export default Error404Message;
